import { ArrowLeft } from "iconsax-reactjs";
import type React from "react";
import { Skeleton } from "@/components/ui/skeleton";

export const SearchResultSkeleton: React.FC = () => {
  return (
    <div className="px-4 py-6 space-y-4">
      {[1, 2, 3, 4, 5].map((i) => (
        <div
          key={`skeleton-${i}`}
          className="flex items-center justify-between py-3 border-b border-stroke-subtle last:border-b-0"
        >
          <Skeleton variant="muted" className="h-5 w-32" />
          <ArrowLeft
            size={20}
            className="text-text-secondary shrink-0"
            style={{ transform: "rotate(-135deg)" }}
          />
        </div>
      ))}
    </div>
  );
};
